<header>
  <div class="contenedor-titulo-header">
    <div class="container-hamburguer" (click)="toggleMenu()">
      <mat-icon>menu</mat-icon>
    </div>
    <span class="titulo-header" *ngIf="!soloBotonMenu" >{{ tituloPagina }}</span>
    <span class="subtitulo-header" *ngIf="tituloPagina !== 'Perfil' && !soloBotonMenu"> - {{ conjunto }}</span>
  </div>
  <div class="contenedor-perfil-header">
    <span class="texto-select-header">{{ conjunto }}</span>
    <a routerLink="/perfil">
      <img [src]="imagenUnidad" alt="Imagen Perfil" />
    </a>
  </div>
</header>
<div class="container-tarjeta-header" *ngIf="!soloBotonMenu" >
  <div class="container-texto-tarjeta">
    <h2>{{ tituloTarjeta }}</h2>
    <!-- <p>{{ textoTarjeta }}</p> -->
  </div>
  <div class="container-imagen-tarjeta">
      <img [src]="imagenTarjeta" alt="">
  </div>
</div>
